export default __webpack_public_path__ + "static/white-lightnin-lemonade-e8b68d442292ff8df6b63ea9a7adc8b2.png";